/* eslint-disable max-len */
import { Node, mergeAttributes } from '@tiptap/core';

export interface ProjectLinkEmbedOptions {
  HTMLAttributes?: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    projectLinkEmbed: {
      setProjectLinkEmbed: (options: {
        url: string;
        projectId: string;
        projectName: string;
        themeMode?: string;
        projectStatusText?: string;
        projectStatusColor?: string;
      }) => ReturnType;
      removeProjectLinkEmbed: () => ReturnType;
    };
  }
}

export const ProjectLinkEmbed = Node.create<ProjectLinkEmbedOptions>({
  name: 'projectLinkEmbed',

  group: 'block',
  atom: true,
  selectable: true,
  draggable: false,

  addAttributes() {
    return {
      url: { default: '' },
      projectId: { default: '' },
      projectName: { default: '' },
      themeMode: { default: 'light' },
      projectStatusColor: { default: 'var(--neutral-primary)' },
      projectStatusText: { default: 'Not Started yet (0%)' }
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div.project-link-embed-preview-main-div',
        getAttrs: (dom: HTMLElement) => {
          return {
            url: dom.getAttribute('url'),
            projectId: dom.getAttribute('projectId'),
            projectName: dom.getAttribute('projectName'),
            themeMode: dom.getAttribute('themeMode'),
            projectStatusColor: dom.getAttribute('projectStatusColor'),
            projectStatusText: dom.getAttribute('projectStatusText')
          };
        }
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const { projectName, projectStatusColor, projectStatusText } = HTMLAttributes;
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        class: 'project-link-embed-preview-main-div',
        url: HTMLAttributes.url,
        projectId: HTMLAttributes?.projectId,
        projectName: HTMLAttributes?.projectName,
        projectStatusColor: projectStatusColor,
        projectStatusText: projectStatusText,
        themeMode: HTMLAttributes?.themeMode
      }),
      [
        'div',
        { class: 'project-content' },
        ['div', { class: 'project-name' }, projectName || 'Unknown Project'],
        [
          'div',
          { class: 'project-progress' },
          [
            'div',
            {
              class: 'project-status-dot',
              style: `background:${projectStatusColor || 'var(--neutral-primary)'};`
            }
          ],
          [
            'div',
            { class: 'project-status-text', style: 'vertical-align:middle;' },
            projectStatusText || 'Not Started yet (0%)'
          ]
        ]
      ]
    ];
  },

  addCommands() {
    return {
      setProjectLinkEmbed:
        (options) =>
        ({ commands }) => {
          console.log('Setting project link embed with options:', options);
          return commands.insertContent({
            type: this.name,
            attrs: options
          });
        },
      removeProjectLinkEmbed:
        () =>
        ({ commands, state }) => {
          const { selection } = state;
          const { $from } = selection;
          const node = $from.node();

          if (node.type.name === this.name) {
            return commands.deleteNode(this.name);
          }
          return false;
        }
    };
  }
});
